// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QJgC","buttons":"styles_buttons__1ZxHf"};